import React, { useContext, useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/appointmentCreator.css";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import TimezoneSelect from "react-timezone-select";
import { DayPilot } from "@daypilot/daypilot-lite-react";

export default function ModifySlot ({ eventData, setEvents, onClose }) {
  const { API_URL } = useContext(UrlContext);
  const [selectedEvent, setSelectedEvent] = useState(eventData);
  const selectedTimeSlot = {
    weekday: new Intl.DateTimeFormat('en-GB', { weekday: 'long' }).format(new Date(selectedEvent.startTime)),
    day: new Intl.DateTimeFormat('en-GB', { day: '2-digit' }).format(new Date(selectedEvent.startTime)),
    month: new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(new Date(selectedEvent.startTime)),
    startTime: new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(selectedEvent.startTime)),
    endTime: new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(selectedEvent.endTime)),
  };

  // Modified dates are not passing!
  const handleStartTimeChange = (e) => {
    const newStartTime = new DayPilot.Date(`${e.target.value}:00`);
    setSelectedEvent(prevSelectedEvent => ({
      ...prevSelectedEvent,
      startTime: newStartTime,
    }));
    console.log('before modifed date', selectedEvent.startTime);
    console.log('after modifed date', newStartTime);
  };
  const handleEndTimeChange = (e) => {
    const newEndTime = new DayPilot.Date(`${e.target.value}:00`);
    setSelectedEvent(prevSelectedEvent => ({
      ...prevSelectedEvent,
      endTime: newEndTime,
    }));
    console.log('before modifed date', selectedEvent.endTime);
    console.log('after modifed date', newEndTime);
  };
  const handleTimezoneChange = (e) => {
    console.log('selected value', e);
    const newTimezone = e.value;
    setSelectedEvent(prevSelectedEvent => ({
      ...prevSelectedEvent,
      timezone: newTimezone,
    }));
  };

  // Api for saving timeslots
  const modifyEvent = async (selectedEvent) => {
    const eventID = selectedEvent.eventID
    const passingValue = {...selectedEvent, startTime: selectedEvent.startTime.value, endTime: selectedEvent.endTime.value};
    const requestBody = {
      event: passingValue,
    };
    try {
      let modifiedUrl = "modify-meeting-time-slot";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        setEvents((prevEvents) => 
          prevEvents.map((event) =>
            event.eventID === eventID ? selectedEvent : event
          )
        );
        console.log('slot successfully modified!')
      } else {
        console.error("Failed to add selected slot");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  console.log('event data', selectedEvent);

  return (
    <div className="decline-wrapper">
      <div className="flex-container-new-event">

        <div className="flex-item-new-event-header">
          <div className="flex-container-new-event-header-div">
            <div className="flex-item-new-event-header-div-left">Modify Slot</div>
            <div className="flex-item-new-event-header-div-right">
              <button className="event-close-button" onClick={onClose}>
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </div>

        <div className='underline-container'>
          <span></span>
        </div>

        <div className="flex-item-new-event-content">
          <div className="flex-container-new-event-content-div">

            <div className="flex-item-new-event-content-div-left">
              <div className="flex-container-new-event-content-div-left-div" style={{marginTop: "5%", overflowY: "auto"}}>

                <div className="flex-item-new-event-content-div-left-div-item">
                  <p className="new-event-form-text">Timezone</p>
                  <TimezoneSelect value={selectedEvent.timezone} onChange={(e) => handleTimezoneChange(e)}/>
                </div>
                <div className="flex-item-new-event-content-div-left-div-item">
                  <p className="new-event-form-text">Start</p>
                  <input
                    className="input-with-underline"
                    type="datetime-local"
                    name="startDate"
                    id="start"
                    value={selectedEvent.startTime.toString()}
                    onChange={handleStartTimeChange}
                  />
                </div>
                <div className="flex-item-new-event-content-div-left-div-item">
                  <p className="new-event-form-text">End</p>
                  <input
                    className="input-with-underline"
                    type="datetime-local"
                    name="startDate"
                    id="end"
                    value={selectedEvent.endTime.toString()}
                    onChange={handleEndTimeChange}
                  />
                </div>

              </div>
            </div>

            <div className="flex-item-new-event-content-div-right">
              <div className="flex-container-new-event-content-div-right-div">
                <div className="flex-item-new-event-content-div-right-div-item" style={{ textAlign: "center", justifyContent: "center", alignItems: "center", display: "flex" }}>
                  <div style={{border: "2px solid darkslategray", padding: "20px", width: "75%", marginTop: "18%"}}>
                    <p>{selectedTimeSlot.weekday}, {selectedTimeSlot.day} {selectedTimeSlot.month} {selectedTimeSlot.startTime} - {selectedTimeSlot.endTime} ({selectedEvent.timezone})</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="flex-item-new-event-action" style={{display: "flex", justifyContent: "flex-end"}}>
          <button className="cancel-decline-button" style={{outline: "none", border: "1px solid lightgray", marginRight: "5px", padding: "3px"}} onClick={onClose}>Cancel</button>
          <button className="decline-button" style={{outline: "none", border: "1px solid lightgray", padding: "3px"}} onClick={(e) => {modifyEvent(selectedEvent); onClose()}}>Modify Slot</button>
        </div>
      </div>
    </div>
  );
}